import { Card, Text, Group, ActionIcon, Menu, Badge } from '@mantine/core';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { AiOutlineDelete } from 'react-icons/ai';
import { PaymentProfile } from '../types';

interface PaymentProfileCardProps {
    paymentProfile: PaymentProfile;
    onDelete?: (id: string) => void;
}

export const PaymentProfileCard = ({ paymentProfile, onDelete }: PaymentProfileCardProps) => {
    const details = paymentProfile.paymentMethodDetails;
    
    return (
        <Card withBorder p="md" radius="md">
            <Group justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                    <Group gap="xs" mb="xs">
                        <Text fw={500}>
                            {details?.card ? `**** **** **** ${details.card.last4}` : paymentProfile.name || 'Payment Method'}
                        </Text>
                        <Badge size="sm" variant="light">
                            {paymentProfile.billingProvider?.name || paymentProfile.billingProviderId}
                        </Badge>
                    </Group>
                    
                    {details?.card && (
                        <Text size="sm" c="dimmed" mb="xs">
                            {details.card.brand?.toUpperCase()} • Expires {details.card.expMonth}/{details.card.expYear}
                        </Text>
                    )}
                    
                    <Text size="xs" c="dimmed">
                        {details?.type || paymentProfile.status}
                    </Text>
                </div>

                {onDelete && (
                    <Menu shadow="md" width={200}>
                        <Menu.Target>
                            <ActionIcon variant="subtle" color="gray">
                                <BsThreeDotsVertical size={16} />
                            </ActionIcon>
                        </Menu.Target>

                        <Menu.Dropdown>
                            <Menu.Item
                                color="red"
                                leftSection={<AiOutlineDelete size={14} />}
                                onClick={() => onDelete(paymentProfile.id)}
                            >
                                Delete
                            </Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                )}
            </Group>
        </Card>
    );
};
